"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.providerSearchResult = void 0;
var providerSearchResult = [
    {
        id: 52007,
        providerUid: "63e07527-51af-4bc5-9b71-4d10b413bb83",
        firstName: "SHAMS",
        middleName: "I",
        lastName: "IQBAL",
        displayName: "IQBAL, SHAMS",
        email: null,
        prefix: null,
        suffix: null,
        degree: null,
        providerType: null,
        pager: null,
        active: null,
        isPcpProvider: null,
        encounterId: null,
        providerServiceLocation: null,
        locations: [],
        identifiers: [
            {
                id: 212057,
                idNumber: "1408426",
                idTypeCode: "EPIC",
                identifierType: "IDNO",
                checkDigit: null,
                checkDigitScheme: null,
                assigningAuthority: {
                    id: 2289,
                    guid: { uuid: "32e9766e-5646-44ac-b5d5-4cc55cba4410" },
                    name: null,
                    description: null,
                    namespaceId: "EPIC",
                    universalId: null,
                    universalIdType: null,
                    defaultIssuer: false,
                    assigningFacility: null
                },
                entityId: null,
                entityType: null,
                primary: true
            }
        ],
        specialties: [],
        subspecialties: []
    }
];
exports.providerSearchResult = providerSearchResult;
//# sourceMappingURL=search-result.js.map